import {
  AnalyticsProvider,
  GetExperimentKey,
  GetTrackingKey,
} from '@volumental/analytic';
import { type JSX, type PropsWithChildren } from 'react';
import { usePersistedViewStore } from '../store';
import { CookieType } from '../types/types';

export function Analytics({ children }: PropsWithChildren): JSX.Element {
  const sp = new URLSearchParams(window.location.search);
  const { cookieType } = usePersistedViewStore((store) => store);

  const debug = false;
  const disabled = false;
  const amplitudeKey = GetTrackingKey();
  const experimentKey = GetExperimentKey();
  return (
    <AnalyticsProvider
      amplitudeApiKey={amplitudeKey}
      experimentKey={experimentKey}
      debugMode={debug}
      disabled={disabled}
      deviceId={sp.get('device_id') || undefined}
      optOut={cookieType === CookieType.Essential}
    >
      {children}
    </AnalyticsProvider>
  );
}
